import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AccountSettingsContainer, AccountSettingsNav } from './AccountSettings.styled'

const AccountSettings = () => {
    const navigate = useNavigate()
    const ACC_SETTING_LINKS = [
        {
        name: "Change Password",
        link: "/change-password",
        },
        {
        name: "Set Withdrawal Pin",
        link: "/set-withdrawal-pin",
        },
        // {
        // name: "Change Withdrawal Address",
        // link: "/withdrawal-address",
        // },
        // {
        // name: "Change Account Name",
        // link: "/change-account-name",
        // },
        // {
        // name: "Update Email Address",
        // link: "/update-email-address",
        // },
        // {
        // name: "Change Avatar",
        // link: "/change-avatar",
        // },
    ]
  return (
    <AccountSettingsContainer>
        {ACC_SETTING_LINKS.map((data, index, row) => <AccountSettingsNav onClick={() => navigate(data.link)}>{data.name}</AccountSettingsNav>)}
    </AccountSettingsContainer>
  )
}

export default AccountSettings